import React from "react";

// Custom vector lettering and a cut-seam D monogram; no font dependency.
function BrandLogo() {
  return (
    <svg className="brand-logo" viewBox="0 0 344 64" aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="2.7" strokeLinecap="round" strokeLinejoin="round">
        <path strokeWidth="3" d="M9 9h18c29 0 29 46 0 46H9V9Zm9 8v30h9c18 0 18-30 0-30H18Z" />
        <path strokeWidth="1.3" d="m5 57 48-50" />
        <path d="M89 15v33m0-12c0-16-24-16-24 0s24 16 24 0Zm10 0c0-16 24-16 24 0s-24 16-24 0Zm34 12V25m0 9c0-13 18-13 18 0v14m0-14c0-13 18-13 18 0v14m13-32v25q0 10 11 6m-17-22h18m31 2v21m0-12c0-16-24-16-24 0s24 16 24 0Zm11 12V25m0 10c0-14 23-14 23 0v13m12-23v23m11-12c0-16 24-16 24 0s-24 16-24 0Zm35 12V25m0 10c0-14 23-14 23 0v13" />
      </g>
      <circle cx="271" cy="16" r="2" fill="currentColor" />
    </svg>
  );
}

export default BrandLogo;
